// src/modules/portal/data/brazilianStates.ts
// Dados dos estados brasileiros para navegação

export interface BrazilianState {
  code: string;
  name: string;
  region: 'Norte' | 'Nordeste' | 'Centro-Oeste' | 'Sudeste' | 'Sul';
  emoji?: string;
  popularDestinations?: string[];
}

export const BRAZILIAN_STATES: BrazilianState[] = [
  // Norte
  { code: 'AC', name: 'Acre', region: 'Norte', popularDestinations: ['Rio Branco'] },
  { code: 'AM', name: 'Amazonas', region: 'Norte', emoji: '🐟', popularDestinations: ['Manaus', 'Barcelos', 'São Gabriel da Cachoeira'] },
  { code: 'AP', name: 'Amapá', region: 'Norte', popularDestinations: ['Macapá'] },
  { code: 'PA', name: 'Pará', region: 'Norte', emoji: '🎣', popularDestinations: ['Santarém', 'Alter do Chão', 'Itaituba'] },
  { code: 'RO', name: 'Rondônia', region: 'Norte', popularDestinations: ['Porto Velho'] },
  { code: 'RR', name: 'Roraima', region: 'Norte', popularDestinations: ['Boa Vista'] },
  { code: 'TO', name: 'Tocantins', region: 'Norte', emoji: '🐠', popularDestinations: ['Palmas', 'Araguaína', 'Lagoa da Confusão'] },
  
  // Nordeste
  { code: 'AL', name: 'Alagoas', region: 'Nordeste', popularDestinations: ['Maceió'] },
  { code: 'BA', name: 'Bahia', region: 'Nordeste', emoji: '🏖️', popularDestinations: ['Salvador', 'Porto Seguro', 'Ilhéus'] },
  { code: 'CE', name: 'Ceará', region: 'Nordeste', popularDestinations: ['Fortaleza'] },
  { code: 'MA', name: 'Maranhão', region: 'Nordeste', popularDestinations: ['São Luís', 'Barreirinhas'] },
  { code: 'PB', name: 'Paraíba', region: 'Nordeste', popularDestinations: ['João Pessoa'] },
  { code: 'PE', name: 'Pernambuco', region: 'Nordeste', popularDestinations: ['Recife', 'Fernando de Noronha'] },
  { code: 'PI', name: 'Piauí', region: 'Nordeste', popularDestinations: ['Teresina'] },
  { code: 'RN', name: 'Rio Grande do Norte', region: 'Nordeste', popularDestinations: ['Natal'] },
  { code: 'SE', name: 'Sergipe', region: 'Nordeste', popularDestinations: ['Aracaju'] },
  
  // Centro-Oeste
  { code: 'DF', name: 'Distrito Federal', region: 'Centro-Oeste', popularDestinations: ['Brasília'] },
  { code: 'GO', name: 'Goiás', region: 'Centro-Oeste', emoji: '🎣', popularDestinations: ['Aruanã', 'São Miguel do Araguaia', 'Luís Alves'] },
  { code: 'MT', name: 'Mato Grosso', region: 'Centro-Oeste', emoji: '🐟', popularDestinations: ['Cuiabá', 'Cáceres', 'Nobres'] },
  { code: 'MS', name: 'Mato Grosso do Sul', region: 'Centro-Oeste', emoji: '🎣', popularDestinations: ['Bonito', 'Corumbá', 'Miranda'] },
  
  // Sudeste
  { code: 'ES', name: 'Espírito Santo', region: 'Sudeste', popularDestinations: ['Vitória'] },
  { code: 'MG', name: 'Minas Gerais', region: 'Sudeste', popularDestinations: ['Belo Horizonte', 'Três Marias'] },
  { code: 'RJ', name: 'Rio de Janeiro', region: 'Sudeste', popularDestinations: ['Rio de Janeiro', 'Cabo Frio'] },
  { code: 'SP', name: 'São Paulo', region: 'Sudeste', popularDestinations: ['São Paulo', 'Registro'] },
  
  // Sul
  { code: 'PR', name: 'Paraná', region: 'Sul', popularDestinations: ['Curitiba', 'Foz do Iguaçu'] },
  { code: 'RS', name: 'Rio Grande do Sul', region: 'Sul', popularDestinations: ['Porto Alegre'] },
  { code: 'SC', name: 'Santa Catarina', region: 'Sul', popularDestinations: ['Florianópolis'] },
];

export const getStateByCode = (code: string): BrazilianState | undefined => {
  return BRAZILIAN_STATES.find(state => state.code === code.toUpperCase());
};

export const getStatesByRegion = (region: string): BrazilianState[] => {
  return BRAZILIAN_STATES.filter(state => state.region === region);
};

export const FISHING_REGIONS = {
  'Norte': ['Amazonas', 'Pará', 'Tocantins'],
  'Centro-Oeste': ['Goiás', 'Mato Grosso', 'Mato Grosso do Sul'],
  'Nordeste': ['Bahia', 'Maranhão'],
  'Sul': ['Paraná', 'Santa Catarina'],
  'Sudeste': ['Minas Gerais', 'Rio de Janeiro', 'São Paulo']
};
